/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Otp from "./Otp.container";

export default Otp;
